// extracted by mini-css-extract-plugin
export default {"input-component__container":"styles_input-component__container__3xP7T","text-label":"styles_text-label__cVL3e","input":"styles_input__V8ZrL"};